export const FETCH_POLICY = {
  CACHE_FIRST: process.env.NODE_ENV !== 'test' ? 'cache-first' : 'no-cache',
  NETWORK_ONLY: process.env.NODE_ENV !== 'test' ? 'network-only' : 'no-cache',
  NO_CACHE: 'no-cache'
} as const;
